import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginModal from '../../../components/LoginModal';
import { PostApi } from '../../../services/CommonService2';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const StateItemGrid = ({ searchData, stateData, setdata }) => {


    const data = useLocation();
    const [course, setCourse] = useState([])
    const [courselist, setCourselist] = useState([]);
    const [modalUp, setModalUp] = useState(false)
    const history = useHistory();
    const didMountRef = useRef(false);
    const [totalRecords, setTotalRecords] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {
        const searchFun = async () => {
            var tntId = JSON.parse(localStorage.getItem('tID'))
            const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
            var reqparams1 = ''
            if (searchData != "") {
                reqparams1 = {
                    pageno: currentPage,
                    query: {
                        status: 'Active',
                        name: { $regex: searchData, $options: "i" },
                        criteria: { $elemMatch: { "branch": stateData.branchid, "year": stateData.academictypeid } }

                    }
                }
            }
            else if (stateData != '') {
                reqparams1 = {
                    pageno: currentPage,
                    query: {
                        status: 'Active',
                        criteria: { $elemMatch: { "branch": stateData.branchid, "year": stateData.academictypeid } }
                    }
                }
            }
            else {
                reqparams1 = {
                    pageno: currentPage,
                    query: {
                        status: '',
                    }
                }
            }

            const action = "ACADEMICCOURSES";
            // console.log("reqparams1",reqparams1);
            

            const ResponseData1 = await PostApi(reqparams1, action);
            setCourselist(ResponseData1?.data?.docs);

            setdata(ResponseData1?.data?.docs)
            setTotalRecords(ResponseData1?.data?.totalDocs)
            // console.log('academics data', ResponseData1);
        }
        searchFun();
    }, [searchData, currentPage, stateData])

    const loginValidate = (data) => {
        localStorage.removeItem('edutype');
        localStorage.setItem("edutype", JSON.stringify('ACADEMICDETAILS'))
        var tntId = JSON.parse(localStorage.getItem('tID'))

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            localStorage.setItem('edutype', JSON.stringify('ACADEMICDETAILS'));
            history.push({
                pathname: "/lmspage2",
                state: data
            })
        }

    }

    const openModal = () => {
        setModalUp(false)
    }

    const logIn = () => {

    }

    const recordsPerPage = 10;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const npage = Math.ceil(totalRecords / recordsPerPage)
    const records = courselist?.slice(firstIndex, lastIndex)
    // console.log("error data",[...Array(npage + 1).keys()].slice(1),npage);
    // console.log("total records",totalRecords);
    const numbers = [...Array(npage + 1).keys()].slice(1)


    const prePage = () => {
        window.scroll(0, 0)
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }


    }
    const changeCPage = (id) => {
        window.scroll(0, 0)
        setCurrentPage(id)

    }
    const nextPage = () => {
        window.scroll(0, 0)
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)

        }
    }
    const goBack = () => {
        history.push("/");
    };

    return (
        <>
            <button className="btn btn-warning" onClick={goBack} style={{ position: "fixed", bottom: "20px", left: "10px", zIndex: 999, width: "30px" }}><i class="fa-solid fa-arrow-left"></i></button>

            <Fragment>

                {courselist.length > 0 ?
                    courselist?.map((data, i) => {

                        let imageid = 'https://visualpathedu.com/static/media/4th-year.15b862d606512e3257c0.jpg';
                        if (data?.image) {
                            imageid = data.image;
                        } else if (data?.image_url) {
                            imageid = data.image_url;
                        }
                        else {
                            imageid = data.imageurl ? data.imageurl : "";
                        }

                        return <Col md="3 py-3" className='mx-auto' key={i}>
                            <div className="card h-100 rounded-4 shadow " onClick={() => loginValidate(data)}>

                                <img src={imageid} className="card-img-top p-2 rounded-4 shadow-md"></img>

                                <div className="course-content d-flex flex-column flex-grow-1 p-3">
                                    <h6 className="heading py-2">{data.name}</h6>
                                    <div className="rating">
                                        {/* <ul className="list-unstyled list-inline">
                                            {data?.duration && <p className='duration2' ><i class="fa-regular fa-clock projects-icon"></i>duration:{data?.duration}</p>}
                                        </ul> */}
                                    </div>
                                    <p className="desc2 py-2">{data.description.slice(0, 100)}</p>
                                    <div class="mt-auto">
                                        <button className="details-btn  btn-warning w-100" >View More</button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    }) :
                    <Col md="12" className="text-center">
                        <h3>No Data Found</h3>
                    </Col>
                }


                {courselist?.length > 0 ? <Col md="12" className="text-center">
                    {/* <Pagination /> */}
                    <div className='mainpagination py-2 d-flex justify-content-center border-1 rounded-4 my-2'>
                        <ul className='pagination'>
                            <li className='page-item'>
                                <label className=' btn btn-outline-success page-link' onClick={prePage}><i class="fa-solid fa-angles-left"></i></label>

                            </li>
                            {numbers.map((n, i) => (
                                <li className={`page-item ${currentPage === n ? 'active' : ""}`} key={i}>
                                    <label className='btn btn-outline-success page-link' onClick={() => changeCPage(n)}>{n}</label>

                                </li>

                            ))}

                            <li className='page-item'>
                                <label className='btn btn-outline-success page-link' onClick={nextPage}><i class="fa-solid fa-angles-right"></i></label>

                            </li>


                        </ul>
                    </div>
                </Col> : ""}

                {modalUp && <LoginModal onClose={openModal} login={logIn}></LoginModal>}
                {/* <ToastContainer /> */}

            </Fragment>
        </>)

}
export default StateItemGrid
